<template>
    <div>
        <div class="pf-grid pr-2 m-2 pb-4"> <!-- Mustafijur: 23-05-2026: Added pb-4-->
            <!-- Outgoing Members & Paid Amount-->
            <div class="pf-card">
                <div class="pf-card-title ml-3">Outgoing Members & Paid Amount</div>
                <div class="report-button-contents mb-4 ml-3">
                    <div class="row">
                        <div class="col-3">
                            <label for="">Select Year:</label>
                            <b-form-select class="" v-model="selected_former_member_year">
                                <b-form-select-option disabled value="" selected>Select Year</b-form-select-option>
                                <b-form-select-option v-for="(year, index) in former_member_years" :key="index"
                                    :value="year.value">{{ year.label }}</b-form-select-option>
                            </b-form-select>
                        </div>
                        <div class="col-3">
                            <label for="">Select Half:</label>
                            <b-form-select class="" v-model="selected_former_member_half">
                                <b-form-select-option disabled value="" selected>Select Half</b-form-select-option>
                                <b-form-select-option v-for="(half, index) in total_halves" :key="index"
                                    :value="half.value">{{ half.text }}</b-form-select-option>
                            </b-form-select>
                        </div>
                        <div class="col d-flex justify-content-end align-items-center pr-3 mt-3">
                            <b-button size="sm" variant="primary" @click="exportOutgoingMembers">
                                <i class="fa fa-download"></i> Export
                            </b-button>
                        </div>
                    </div>
                </div>
                <b-overlay :show="formerMemberShowOverlay" rounded="sm" class="full-overlay">
                <pf-outgoing-members-bar
                    :key="outgoing_members_chart_key"
                    ref="outgoingMembers"
                    :periods="former_member_periods_show"
                    :outgoing-counts="former_member.counts"
                    :paid-amounts-cr="former_member.paidCr" />
                </b-overlay>
            </div>

            <!-- PF Contribution (Both) -->
            <div class="pf-card">
                <div class="pf-card-title ml-3">PF Contribution (Both)</div>
                <div class="report-button-contents mb-4 ml-3">
                    <div class="row">
                        <div class="col-3">
                            <label for="">Select Year:</label>
                            <b-form-select class="" v-model="selected_pf_contribution_year">
                                <b-form-select-option disabled value="" selected>Select Year</b-form-select-option>
                                <b-form-select-option v-for="(year, index) in pf_contribution_years" :key="index"
                                    :value="year.value">{{ year.label }}</b-form-select-option>
                            </b-form-select>
                        </div>
                        <div class="col-3">
                            <label for="">Select Half:</label>
                            <b-form-select class="" v-model="selected_pf_contribution_half">
                                <b-form-select-option disabled value="" selected>Select Half</b-form-select-option>
                                <b-form-select-option v-for="(half, index) in total_halves" :key="index"
                                    :value="half.value">{{ half.text }}</b-form-select-option>
                            </b-form-select>
                        </div>

                        <div class="col d-flex justify-content-end align-items-center pr-3 mt-3">
                            <b-button size="sm" variant="primary" @click="exportPfContributions">
                                <i class="fa fa-download"></i> Export
                            </b-button>
                        </div>
                    </div>
                </div>
                <b-overlay :show="totalContributionShowOverlay" rounded="sm" class="full-overlay">
                <pf-contribution-chart
                    :key="pf_contribution_chart_key"
                    ref="pfContributions"
                    :periods="total_pf_contributions_show"
                    :contribution-employee="total_contribution.contributionEmployee"
                    :contribution-employer="total_contribution.contributionEmployer"
                    :total-employees="total_contribution.totalEmployees" />
                </b-overlay>
            </div>

            <!-- PF Membership Status -->
            <div class="pf-card">
                <div class="pf-card-title ml-3">PF Membership Status</div>
                <div class="report-button-contents mb-4 ml-3">
                    <div class="row">
                        <div class="col-3">
                            <label for="">Select Year:</label>
                            <b-form-select class="" v-model="selected_pf_membership_year">
                                <b-form-select-option disabled value="" selected>Select Year</b-form-select-option>
                                <b-form-select-option v-for="(period, index) in pf_membership_years" :key="index"
                                    :value="period.value">{{ period.label }}</b-form-select-option>
                            </b-form-select>
                        </div>
                        <div class="col-3">
                            <label for="">Select Half:</label>
                            <b-form-select class="" v-model="selected_pf_memebership_month">
                                <b-form-select-option disabled value="" selected>Select Month</b-form-select-option>
                                <b-form-select-option v-for="(half, index) in pf_membership_months" :key="index"
                                    :value="half.value">{{ half.text }}</b-form-select-option>
                            </b-form-select>
                        </div>
                    </div>
                </div>
                <b-overlay :show="membershipShowOverlay" rounded="sm" class="full-overlay">
                <pf-membership-status-chart :pf_membership_status="pf_membership_status"/>
                </b-overlay>
            </div>


        </div>

        <!-- PF Dashboard Summary -->

    </div>

</template>

<script>
export default {
    name: 'PFDashboard',
    data() {
        return {
            total_halves: [
                { value: 1, text: '1st Half' },
                { value: 2, text: '2nd Half' }
            ],

            periods: ["Jun'23", "Dec'23", "Jun'24", "Dec'24"],

            month_names: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],

            fund_balance_periods: this.generateYears(),

            // Former Member
            selected_former_member_year: '',
            selected_former_member_half: '',
            former_member_years: this.generateYears(),
            former_member_periods_show: [],
            former_member: {
                counts: [],
                paidCr: [],
            },

            // PF Contribution Both
            selected_pf_membership_year: new Date().getFullYear(),
            selected_pf_memebership_month: String(new Date().getMonth() + 1), // +1 because getMonth() is 0-indexed

            pf_contribution_years: this.generateYears(),
            total_pf_contributions_show: [],

            // PF Membership Status

            pf_membership_years: Array.from(
                { length: new Date().getFullYear() - 2020 + 1 },
                (_, i) => ({ value: 2020 + i, label: String(2020 + i) })
            ),

            pf_membership_months: [
                { value: "1", text: "January" },
                { value: "2", text: "February" },
                { value: "3", text: "March" },
                { value: "4", text: "April" },
                { value: "5", text: "May" },
                { value: "6", text: "June" },
                { value: "7", text: "July" },
                { value: "8", text: "August" },
                { value: "9", text: "September" },
                { value: "10", text: "October" },
                { value: "11", text: "November" },
                { value: "12", text: "December" },
            ],
            total_contribution: {
                contributionEmployee: [25.4, 26.8, 28.5, 30.2],
                contributionEmployer: [25.4, 26.8, 28.5, 30.2],
                totalEmployees: [265, 278, 295, 315]
            },

            pf_membership_status: [],

            formerMemberShowOverlay: false,
            totalContributionShowOverlay: false,
            membershipShowOverlay: false,
            discontinuedEmployeesShowOverlay: false,
            outgoing_members_chart_key: 0,
            pf_contribution_chart_key: 0,
        };
    },

    watch: {
        selected_former_member_year(newVal, oldVal) {
            this.getFormerMemberChart();
        },
        selected_former_member_half(newVal, oldVal) {
            this.getFormerMemberChart();
        },

        selected_pf_contribution_year(newVal, oldVal) {
            this.getTotalContribution();
        },

        selected_pf_contribution_half(newVal, oldVal) {
            this.getTotalContribution();
        },

        selected_pf_membership_year(newVal, oldVal) {
             this.getPfMembershipStatusChart();
        },
        selected_pf_memebership_month(newVal, oldVal) {
             this.getPfMembershipStatusChart();
        },

    },
    methods: {
        exportOutgoingMembers() {
            try {
            this.$refs.outgoingMembers?.exportPng('Outgoing_Members_Paid_Amount.png');
            } catch (e) {
            console.error('Export failed:', e);
            }
        },

        exportPfContributions() {
            try {
            this.$refs.pfContributions?.exportPng('PF_Contributions.png');
            } catch (e) {
            console.error('Export failed:', e);
            }
        },
        generateYears() {
            const periods = [];
            const currentYear = new Date().getFullYear();

            for (let year = currentYear; year >= 2020; year--) {
                // Fiscal Year
                periods.push({
                    value: `${year}-${year+1}`,
                    label: `${year}-${year+1}`
                });
            }

            return periods;
        },

        getFormerMemberChart() {
            this.formerMemberShowOverlay = true;
            if (!this.selected_former_member_year || !this.selected_former_member_half) {
                this.formerMemberShowOverlay = false;
                return;
            }

            let url = this.$api_url + '/pf/trustee/get-former-member-chart-data';

            let formData = new FormData();

            formData.append('year', this.selected_former_member_year);
            formData.append('half', this.selected_former_member_half);

            axios.post(url, formData).then(function (response) {
                this.formerMemberShowOverlay = false;
                if (response.data.errors) {
                    return;
                }

                const data = response.data;
                this.former_member_periods_show = [];
                this.former_member.counts = [];
                this.former_member.paidCr = [];

                Object.keys(data).sort().forEach(dateStr => {
                    const item = data[dateStr];

                    const date = new Date(dateStr);
                    const half = (date.getMonth() < 6) ? "H1" : "H2";
                    const formattedPeriod = `${half}'${String(date.getFullYear()).slice(-2)}`;

                    this.former_member_periods_show.push(formattedPeriod);

                    this.former_member.counts.push(item.total_leavers);
                    this.former_member.paidCr.push(item.total_paid_amount);

                });
                this.outgoing_members_chart_key += 1;

            }.bind(this))
                .catch(error => {
                    if (error.response) {
                    }
                });
        },
        getTotalContribution() {
            this.totalContributionShowOverlay = true;
            if (!this.selected_pf_contribution_year || !this.selected_pf_contribution_half) {
                this.totalContributionShowOverlay = false;
                return;
            }

            let url = this.$api_url + '/pf/trustee/get-total-contribution';

            let formData = new FormData();

            formData.append('year', this.selected_pf_contribution_year);
            formData.append('half', this.selected_pf_contribution_half);

            axios.post(url, formData).then(function (response) {
                this.totalContributionShowOverlay = false;
                if (response.data.errors) {
                    return;
                }

                const data = response.data;
                this.total_pf_contributions_show = []
                this.total_contribution.contributionEmployee = [];
                this.total_contribution.contributionEmployer = [];
                this.total_contribution.totalEmployees = [];

                Object.keys(data).sort().forEach(dateStr => {
                    const item = data[dateStr];

                    const date = new Date(dateStr);
                    const half = (date.getMonth() < 6) ? "H1" : "H2";
                    const formattedPeriod = `${half}'${String(date.getFullYear()).slice(-2)}`;

                    this.total_pf_contributions_show.push(formattedPeriod);

                    this.total_contribution.contributionEmployee.push(item.employee_contribution);
                    this.total_contribution.contributionEmployer.push(item.employer_contribution);
                    this.total_contribution.totalEmployees.push(item.total_employees);
                });
                this.pf_contribution_chart_key += 1;
            }.bind(this))
                .catch(error => {
                    if (error.response) {
                    }
                });
        },
        getPfMembershipStatusChart() {
            this.membershipShowOverlay = true;
            if (!this.selected_pf_membership_year || !this.selected_pf_memebership_month) {
                this.membershipShowOverlay = false;
                return;
            }

            let url = this.$api_url + '/pf/trustee/get-membership-status-chart-data';

            let formData = new FormData();

            formData.append('year', this.selected_pf_membership_year);
            formData.append('month', this.selected_pf_memebership_month);

            axios.post(url, formData).then(function (response) {
                this.membershipShowOverlay = false;
                if (response.data.errors) {
                    return;
                }
                const data = response.data;
                this.pf_membership_status = data;
            }.bind(this))
            .catch(error => {
                if (error.response) {
                }
            });
        },
    },
    created: function () {

    },
    mounted() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1);

        this.selected_former_member_year = (year-1)+'-'+year;
        this.selected_former_member_half = 1;

        this.selected_pf_contribution_year = (year-1)+'-'+year;
        this.selected_pf_contribution_half = 1;

        this.selected_pf_membership_year = year;
        this.selected_pf_memebership_month = month;

        this.getFormerMemberChart();
        this.getTotalContribution();
        this.getPfMembershipStatusChart();
    },

    computed: {}
};
</script>

<style scoped>
.pf-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 18px;
}

.pf-title {
    grid-column: 1/-1;
    margin: 6px 0 4px;
    font-weight: 700;
}

.pf-card {
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 14px;
    padding: 12px 14px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .04);
}

.pf-card-title {
    font-weight: 600;
    margin: 2px 0 8px;
    color: #0064b5;
    font-size: 20px;
}

/* Rejwan: 04-09-2025  */
@media (max-width: 1024px) {
    .pf-grid {
        grid-template-columns: 1fr;
    }
}
</style>
